import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import i18n from "@/lib/i18n";
import { apiKeysApi } from "@/features/apikeys/api";
import { apiKeysKeys } from "@/features/apikeys/query-keys";

export function useApiKeysQuery() {
  return useQuery({
    queryKey: apiKeysKeys.list(),
    queryFn: apiKeysApi.list,
  });
}

export function useCreateApiKeyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => apiKeysApi.create(name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeysKeys.list() });
    },
  });
}

export function useRevokeApiKeyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiKeysApi.revoke,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeysKeys.list() });
      toast.success(i18n.t("apiKeys.toast.revoked"));
    },
  });
}
